import './jsxdev';
import React from 'react';
import Home from './pages/Home';
import { BrowserRouter as Router } from 'react-router-dom';

const App: React.FC = () => {
  return (
    <div className="App">
      <Router>
        <Home />
      </Router>
    </div>
  );
};

export default App;
